module.exports = __webpack_public_path__ + "static/media/Booking-Payment-Confirm.70ec4e89.png";